<div class="app-container">
  <router-outlet></router-outlet>

<!-- Global Loader Component -->
<app-loader></app-loader>
</div>
